import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [firm, setFirm] = useState(() => { try { return JSON.parse(localStorage.getItem("legalos_firm")) || null; } catch { return null; } });

  useEffect(() => {
    if (!localStorage.getItem("legalos_token")) return setUser(false);
    api.get("/auth/me").then((r) => { const { firm: f, ...u } = r.data; setUser(u); if (f) { setFirm(f); localStorage.setItem("legalos_firm", JSON.stringify(f)); } }).catch(() => setUser(false));
  }, []);

  const login = useCallback((token, u, f) => {
    localStorage.setItem("legalos_token", token);
    if (f) { localStorage.setItem("legalos_firm", JSON.stringify(f)); setFirm(f); }
    setUser(u);
    api.get("/auth/me").then((r) => { const { firm: ff, ...uu } = r.data; setUser(uu); }).catch(() => {});
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("legalos_token");
    localStorage.removeItem("legalos_firm");
    setUser(false); setFirm(null);
  }, []);

  return <AuthContext.Provider value={{ user, firm, setFirm, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
